import IntentsTabsLayout from './IntentsTabsLayout.vue';
import Intents from './Intents.vue';

const rootRoute = {
  path: 'intents',
  name: 'Intents',
  component: IntentsTabsLayout,
  meta: {
    auth: true,
    permissioned: true,
    basePath: '/iqtools/intents',
  },
  props: {
    useLayout: false,
    baseResource: '/iqtools/intents',
  },
};

const commonChildMeta = {
  auth: true,
  permissioned: true,
  resource: rootRoute.path,
  parentName: rootRoute.name,
};

const childRoutes = [
  {
    path: '',
    name: 'IQTools.Intents.Intents',
    component: Intents,
    meta: {
      label: 'Intents',
      permissionAlias: '/iqtools/intents',
      ...commonChildMeta,
    },
  },
  // Sharing the same permission between the intent and recommendation page.
  {
    path: 'recommendations',
    name: 'IQTools.Intents.IntentRecommendation',
    component: () => import('./IntentRecommendation.vue'),
    meta: {
      label: 'AI Recommendations',
      permissionAlias: '/iqtools/intents',
      ...commonChildMeta,
    },
  },
];

rootRoute.children = childRoutes;
export default rootRoute;
